import React from 'react';
import Skeleton from 'react-loading-skeleton';
import PropTypes from 'prop-types';

const UserProfileSkeleton = ({ isMobile }) => (
  <div className="profile_view">
    <Skeleton width="34px" height="34px" circle />
    {!isMobile ? (
      <div className="user_ic">
        <Skeleton width="86px" height="24px" />
      </div>
    ) : null}
  </div>
);

UserProfileSkeleton.propTypes = {
  isMobile: PropTypes.bool.isRequired,
};

export default UserProfileSkeleton;
